<template>
    <div :class="[{'app-en':lang === 'en'}, 'app-canvas-wrap']">
        <Nav ref="navchild"></Nav>
        <Loader :speed="loadprogress" v-if="!hadLoaded" />
        <div ref="webgl" id="webgl"></div>
        <!-- logo -->
        <div class="logo">
            <a href="/"><img src="../assets/logo.png" /></a>
        </div>
        <!-- CN|EN -->
        <language @custom-event="handleChildEvent" />
        <!-- 菜单栏 -->
        <div class="app-toolbar">
            <div class="app-toolbar-circle">
                <div class="ring"></div>
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="100%">
                    <g class="ring">
                        <g class="toolbar-item" @click="openLink()">
                            <path
                                d="M 482.13602837739217 125.84452286971282 L 452.40303192456616 51.57508822842692 A 720 720 0 0 1 583.7391040605069 13.011337970850718 L 598.8792036093395 91.56563375186738 A 640 640  0 0 0 482.13602837739217 125.84452286971282 z"
                                fill="transparent" stroke="transparent" stroke-width="0">
                            </path>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="45" v-if="lang == 'cn'">
                                <textPath xlink:href="#SvgjsPath1031">官 网</textPath>
                            </text>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="36" v-if="lang == 'en'">
                                <textPath xlink:href="#SvgjsPath1031">Website</textPath>
                            </text>
                        </g>
                        <g :class="[{'active':toobarActive == 'upper'}, 'toolbar-item']" @click="selectToobar('upper')">
                            <path
                                d="M 598.8792036093395 91.56563375186738 L 583.7391040605069 13.011337970850718 A 720 720 0 0 1 720.0000000000024 0 L 720.0000000000022 80 A 640 640  0 0 0 598.8792036093395 91.56563375186738 z"
                                fill="transparent" stroke="transparent" stroke-width="0">
                            </path>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="45" v-if="lang == 'cn'">
                                <textPath xlink:href="#SvgjsPath1032">拆 卸</textPath>
                            </text>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="10" v-if="lang == 'en'">
                                <textPath xlink:href="#SvgjsPath1032">Disassemble</textPath>
                            </text>
                        </g>
                        <g :class="[{'active':toobarActive == 'down'}, 'toolbar-item']" @click="selectToobar('down')">
                            <path
                                d="M 720 80 L 720 0 A 720 720 0 0 1 856.2608959394953 13.011337970851173 L 841.1207963906625 91.56563375186772 A 640 640  0 0 0 720 80 z"
                                fill="transparent" stroke="transparent" stroke-width="0">
                            </path>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="45" @mouseenter="greet" v-if="lang == 'cn'">
                                <textPath xlink:href="#SvgjsPath1000">装 配</textPath>
                            </text>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="28" @mouseenter="greet" v-if="lang == 'en'">
                                <textPath xlink:href="#SvgjsPath1000">Assemble</textPath>
                            </text>
                        </g>
                        <g :class="[{'active':toobarActive == 'outer'}, 'toolbar-item']" @click="selectToobar('outer')">
                            <path
                                d="M 841.1207963906625 91.56563375186772 L 856.2608959394953 13.011337970851173 A 720 720 0 0 1 987.5969680754358 51.57508822842772 L 957.8639716226096 125.8445228697135 A 640 640  0 0 0 841.1207963906625 91.56563375186772 z"
                                fill="transparent" stroke="transparent" stroke-width="0">
                            </path>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="45" v-if="lang == 'cn'">
                                <textPath xlink:href="#SvgjsPath1001">调 节</textPath>
                            </text>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="38" v-if="lang == 'en'">
                                <textPath xlink:href="#SvgjsPath1001">Adjust
</textPath>
                            </text>
                          </g>
                          <!-- 椭圆  A(rx, ry, xr, laf, sf, x, y)
                          rx: 椭圆X轴半径
                          ry: 椭圆Y轴半径
                          xr: 椭圆旋转角度
                          laf: 是否选择弧长较长的那一段。0: 短边（小于180度）; 1: 长边（大于等于180度）
                          sf: 是否顺时针绘制。0: 逆时针; 1: 顺时针
                          x: 终点X轴坐标
                          y: 终点Y轴坐标 -->
                    </g>
                    <defs>
                        <path id="SvgjsPath1000"
                            d="M 720 49 L 720 48 A 672 672 0 0 1 847.1768362101957 60.143915439461125 L 846.9875849658353 61.1258441367238 A 671 671  0 0 0 720 49 z">
                        </path>
                        <path id="SvgjsPath1001"
                            d="M 846.9875849658353 61.1258441367238 L 847.1768362101957 60.143915439461125 A 672 672 0 0 1 969.7571702037401 96.13674901319928 L 969.3855077480798 97.06511694621531 A 671 671  0 0 0 846.9875849658353 61.1258441367238 z">
                        </path>
                        <path id="SvgjsPath1031"
                            d="M 470.6144922519221 97.06511694621452 L 470.2428297962618 96.13674901319848 A 672 672 0 0 1 592.8231637898064 60.14391543946067 L 593.0124150341668 61.12584413672346 A 671 671  0 0 0 470.6144922519221 97.06511694621452 z">
                        </path>
                        <path id="SvgjsPath1032"
                            d="M 593.0124150341668 61.12584413672346 L 592.8231637898064 60.14391543946067 A 672 672 0 0 1 720.0000000000023 48 L 720.0000000000023 49 A 671 671  0 0 0 593.0124150341668 61.12584413672346 z">
                        </path>
                    </defs>
                </svg>
            </div>
            <!-- swiper-start -->
            <div class="app-submenu-wrap swiper" v-if="toobarActive === 'upper'">
                <div class="arrow-left"></div>
                <swiper ref="mySwiper" :options="swiperOption">
                    <div
                      class="swiper-slide"
                      v-for="(item,index) in upperObj"
                      :key="index"
                      :class="[{'active':upperActive === item.id}, 'app-submenu-item']"
                      @click="upperAnimate(item)"
                    >
                        <template v-if="lang == 'cn'">
                            {{ item.text }}
                        </template>
                        <template v-if="lang == 'en'">
                            {{ item.en_text }}
                        </template>
                    </div>

                  </swiper>
                  <!-- 如果需要导航按钮 -->
                <div class="arrow-right"></div>
            </div>
            <div class="app-submenu-wrap swiper" v-if="toobarActive === 'down'">
                <div class="arrow-left"></div>
                <swiper ref="mySwiper2" :options="swiperOption">
                    <div
                      class="swiper-slide"
                       v-for="(item,index) in downObj"
                      :key="index"
                      :class="[{'active':downActive === item.id}, 'app-submenu-item']"
                      @click="downAnimate(item)"
                    >
                        <template v-if="lang == 'cn'">
                            {{ item.text }}
                        </template>
                        <template v-if="lang == 'en'">
                            {{ item.en_text }}
                        </template>
                    </div>
                </swiper>
                <!-- 如果需要导航按钮 -->
                <div class="arrow-right"></div>
            </div>

            <div class="app-submenu-wrap" v-if="toobarActive === 'outer'">
                    <div
                      v-for="(item,index) in outerObj"
                      :key="index"
                      :class="[{'active':outerActive === item.id}, 'app-submenu-item']"
                      @click="outerAnimate(item)"
                      :style="{'margin': '4px 8px'}"
                    >
                        <template v-if="lang == 'cn'">
                            {{ item.text }}
                        </template>
                        <template v-if="lang == 'en'">
                            {{ item.en_text }}
                        </template>
                    </div>
            </div>
        </div>
        <div class="Mask" v-if="!dimension_1_status" @click="resetdimension(2)">
          <div class="Mask_img" v-if="!dimension_1_status">
            <img src="../assets/images/bgxkskkzz_opcity.jpg" alt="" srcset="">
          </div>
        </div>
        <!-- 注意事项文字 -->
        <transition>
          <div class="app-text" v-if="attentionStatus&&attentionText">
            <div class="title" @click="shownote()">
                <img src="../assets/images/text.png" />
                <span  v-show="lang == 'cn'">注意</span>
                <span  v-show="lang == 'en'">NOTE</span>
            </div>
            <div class="content" v-html="attentionText" v-show="is_hidenote"></div>
          </div>
        </transition>

        <!-- <div @click="test" class="test">测试</div> -->

    </div>
</template>

<script>
    import * as THREE from  'three';
    import TWEEN from '@tweenjs/tween.js';
    import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
    import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
    import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';
    import { MeshoptDecoder } from 'three/examples/jsm/libs/meshopt_decoder.module.js'

    // import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
    // import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
    // import { OutlinePass  } from 'three/examples/jsm/postprocessing/OutlinePass.js';
    // // ShaderPass功能：使用后处理Shader创建后处理通道
    // import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js';
    // // FXAA抗锯齿Shader
    // import { FXAAShader } from 'three/examples/jsm/shaders/FXAAShader.js';
    // // SMAA抗锯齿通道
    // import { SMAAPass } from 'three/examples/jsm/postprocessing/SMAAPass.js';
    // // 伽玛校正后处理Shader
    // import { GammaCorrectionShader } from 'three/examples/jsm/shaders/GammaCorrectionShader';
    // import { CSS2DRenderer,CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer.js';
    // // 引入CSS3渲染器CSS3DRenderer
    // // import { CSS3DRenderer,CSS3DObject } from 'three/examples/jsm/renderers/CSS3DRenderer.js';

    import Loader from './Loader.vue';
    import Nav from './nav.vue';
    import language from './language.vue';

    import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
    import 'swiper/css/swiper.css'

    export default {

        components: {
            Loader,
            Nav,
            language,
            Swiper,
            SwiperSlide
        },

        data() {
            return {
                timer: null, // 定时器
                hadLoaded: false, // 是否已加载完毕
                loadprogress: 0, // 加载进度
                modelLoaded: false, // 模型是否加载

                Clock: null, // 用于跟踪时间
                camera: null, // 相机对象
                renderer: null, // 渲染器对象
                container: null, // DOM节点
                controls: null, // 轨道控制器
                containerW: 0, // DOM宽度
                containerH: 0, // DOM高度
                model: null, //模型
                toobarActive: null, // 工具栏状态
                is_hidenote:true,

                upperActive: null, //拆卸步骤
                downActive: null, //装配步骤
                outerActive:null, //调节
                modelanimationList:[], //动画列表
                selectobject:null,
                dimension_1:null,
                dimension_1_status:true,

                attentionStatus: false, // 注意事项状态
                attentionText: null, // 注意事项文字

                lang: 'cn', // 语言
                upperObj:[ //拆卸选项
                  {
                    id: 0,
                    text: '第1步', //菜单显示
                    en_text: 'Step 1', //菜单显示(英文)
                    warn: '<p>1.逆时针旋转侧板顶持螺丝，取出顶持侧板、小侧板及密封片</p>',
                    en_warn: '<p>Rotate the side plate supporting screw counterclockwise to remove the supporting side plate, small side plate, and sealing gasket</p>',
                    animate_number: '1',
                  },
                  {
                    id: 1,
                    text: '第2步', //菜单显示
                    en_text: 'Step 2', //菜单显示(英文)
                    warn: '<p>2.拆去侧板固定螺丝，取下侧板</p>',
                    en_warn: '<p>2.Remove the side plate fixing screws and take off the side plate.</p>',
                    animate_number: '3',
                  },
                  {
                    id: 2,
                    text: '第3步', //菜单显示
                    en_text: 'Step 3', //菜单显示(英文)
                    warn: '<p>3.拆去盖板螺丝，取下盖板</p>',
                    en_warn: '<p>3.Remove the cover plate screws and take off the cover plate.</p>',
                    animate_number: '4',
                  },
                  {
                    id: 3,
                    text: '第4步', //菜单显示
                    en_text: 'Step 4', //菜单显示(英文)
                    warn: '<p>4.拆去指针螺丝，取下指针</p>',
                    en_warn: '<p>4.Remove the pointer screws and remove the pointer.</p>',
                    animate_number: '5',
                  },
                  {
                    id: 4,
                    text: '第5步', //菜单显示
                    en_text: 'Step 5', //菜单显示(英文)
                    warn: '<p>5.拆去调节螺母压块螺丝，取下压块</p>',
                    en_warn: '<p>5.Remove the adjusting nut pressure block screws and take off the pressure block.</p>',
                    animate_number: '6',
                  },
                  {
                    id: 5,
                    text: '第6步', //菜单显示
                    en_text: 'Step 6', //菜单显示(英文)
                    warn: '<p>6.取下外侧轴承，逆时针旋出调节螺母，同时取下内侧轴承</p>',
                    en_warn: '<p>6.Remove the outer bearing by counterclockwise rotation, simultaneously unscrew the adjusting nut, and take off the inner bearing.</p>',
                    animate_number: '7',
                  },
                  {
                    id: 6,
                    text: '第7步', //菜单显示
                    en_text: 'Step 7', //菜单显示(英文)
                    warn: '<p>7.拆去调节螺母垫块螺丝，取下垫块</p>',
                    en_warn: '<p>7.Remove the adjusting nut spacer screw and take off the spacer.</p>',
                    animate_number: '8',
                  },
                  {
                    id: 7,
                    text: '第8步', //菜单显示
                    en_text: 'Step 8', //菜单显示(英文)
                    warn: '<p>8.用专用工具取出摆杆销轴</p>',
                    en_warn: '<p>8.Use a specialized tool to extract the swing rod pin axis.</p>',
                    animate_number: '9',
                  },
                  {
                    id: 8,
                    text: '第9步', //菜单显示
                    en_text: 'Step 9', //菜单显示(英文)
                    warn: '<p>9.拆下压板螺丝，取下压板</p>',
                    en_warn: '<p>9.Remove the pressure plate screws and take off the pressure plate.</p>',
                    animate_number: '10',
                  },
                  {
                    id: 9,
                    text: '第10步', //菜单显示
                    en_text: 'Step 10', //菜单显示(英文)
                    warn: '<p>10.将拉杆与摆杆从侧面取出</p>',
                    en_warn: '<p>10.Remove the connecting rod and swing arm from the side..</p>',
                    animate_number: '2',
                  },
                ],
                downObj: [ //装配选项
                  {
                    id: 10,
                    text: '第1步', //菜单显示
                    en_text: 'Step 1', //菜单显示(英文)
                    warn: '<p>1.将拉杆与摆杆从侧面装入</p>',
                    en_warn: '<p>1.Insert the connecting rod and swing arm from the side.</p>',
                    animate_number: '13',
                  },
                  {
                    id: 11,
                    text: '第2步', //菜单显示
                    en_text: 'Step 2', //菜单显示(英文)
                    warn: '<p>2.装上压板，拧入压板螺丝</p>',
                    en_warn: '<p>2.Install the pressure plate and tighten the pressure plate screws.</p>',
                    animate_number: '15',
                  },
                  {
                    id: 12,
                    text: '第3步', //菜单显示
                    en_text: 'Step 3', //菜单显示(英文)
                    warn: '<p>3.用专用工具装入摆杆销轴</p>',
                    en_warn: '<p>3.Use a specialized tool to insert the swing rod pin axis.</p>',
                    animate_number: '16',
                  },
                  {
                    id: 13,
                    text: '第4步', //菜单显示
                    en_text: 'Step 4', //菜单显示(英文)
                    warn: '<p>4.装上垫块，拧上调节螺母垫块螺丝</p>',
                    en_warn: '<p>4.Install the spacer, screw in the adjusting nut spacer screw.</p>',
                    animate_number: '17',
                  },
                  {
                    id: 14,
                    text: '第5步', //菜单显示
                    en_text: 'Step 5', //菜单显示(英文)
                    warn: '<p>5.装上内侧轴承，顺时针旋入调节螺母，装上外侧轴承</p>',
                    en_warn: '<p>5.Install the inner bearing, clockwise rotate the adjusting nut, and install the outer bearing.</p>',
                    animate_number: '18',
                  },
                  {
                    id: 15,
                    text: '第6步', //菜单显示
                    en_text: 'Step 6', //菜单显示(英文)
                    warn: '<p>6.装上压块，拧入调节螺母压块螺丝</p>',
                    en_warn: '<p>6.Install the pressure block, screw in the adjusting nut pressure block screws.</p>',
                    animate_number: '19',
                  },
                  {
                    id: 16,
                    text: '第7步', //菜单显示
                    en_text: 'Step 7', //菜单显示(英文)
                    warn: '<p>7.放入指针，拧入指针螺丝</p>',
                    en_warn: '<p>7.Insert the pointer and screw in the pointer screw..</p>',
                    animate_number: '20',
                  },
                  {
                    id: 17,
                    text: '第8步', //菜单显示
                    en_text: 'Step 8', //菜单显示(英文)
                    warn: '<p>8.装上盖板，拧入盖板螺丝</p>',
                    en_warn: '<p>8.Install the cover plate and screw in the cover plate screws.</p>',
                    animate_number: '21',
                  },
                  {
                    id: 18,
                    text: '第9步', //菜单显示
                    en_text: 'Step 9', //菜单显示(英文)
                    warn: '<p>9.放上侧板，拧入侧板固定螺丝</p>',
                    en_warn: '<p>9.Place the side plate and screw in the side plate fixing screws.</p>',
                    animate_number: '22',
                  },
                  {
                    id: 19,
                    text: '第10步', //菜单显示
                    en_text: 'Step 10', //菜单显示(英文)
                    warn: '<p>10.放入顶持侧板、小侧板及密封片，顺时针旋转侧板顶持螺丝</p>',
                    en_warn: '<p>10.Place the supporting side plate, small side plate, and sealing gasket, clockwise rotate the side plate supporting screw.</p>',
                    animate_number: '14',
                  },
                ],
                outerObj:[ //调节选项
                  {
                    id: 0,
                    text: '顺时针', //菜单显示
                    en_text: 'clockwise', //菜单显示(英文)
                    warn: '<p>1.顺时针转动调节螺母(青色标记)，拉杆（蓝色标记）在拉力作用下向左移动，拉杆（蓝色标记）与摆杆（黄色标记）之间夹角变大，摆杆（黄色标记）会推动模唇部分（洋红色标记）向上移动，最终模唇间隙变小，实现快速调节。</p>',
                    en_warn: '<p>1.Rotate the adjusting nut (marked in cyan) clockwise, the rod (marked in blue) moves to the left under tension, increasing the angle between the rod (marked in blue) and the swing arm (marked in yellow). The swing arm (marked in yellow) pushes the lip part (marked in magenta) upward, reducing the lip gap for quick adjustment</p>',
                    animate_number: '11',
                  },
                  {
                    id: 1,
                    text: '逆时针', //菜单显示
                    en_text: 'anticlockwise', //菜单显示(英文)
                    warn: '<p>2.2、反之逆时针转动调节螺母(青色标记)，模唇间隙变大。</p>',
                    en_warn: '<p>2.Conversely, rotate the adjusting nut (marked in blue) counterclockwise, increasing the lip gap.</p>',
                    animate_number: '12',
                  },
                ],
            }
        },

        mounted: function () {
            let _this = this;

            _this.initCanvas();

            _this.timer = setInterval(function() {
                if ( !_this.hadLoaded ) {
                    if ( _this.loadprogress < 80 ) {
                        _this.loadprogress += 0.8;
                    } else if ( _this.modelLoaded ) {
                        if ( _this.loadprogress <= 100 ) {
                            _this.loadprogress += 2;
                        } else {
                            _this.hadLoaded = true;
                            clearInterval(_this.timer);
                            _this.timer = null;
                        }
                    }
                }
            }, 20);
            this.raycasterclick()

            _this.swiperOption = {
              slidesPerView : 3,
              spaceBetween : 10,
              breakpoints: {
                996: {  //当屏幕宽度大于等于768
                  slidesPerView: 5,
                  spaceBetween: 20
                },
              },
               // 如果需要前进后退按钮
              navigation: {
                prevEl: '.arrow-left',
                nextEl: '.arrow-right',
              },
              on:{
                init: function(){
                  // this.slideTo(0);
                },
                click: function(){
                  if(this.clickedIndex-this.activeIndex == this.params.slidesPerView-1){
                    this.slideNext()
                  }else if(this.clickedIndex-this.activeIndex == 0){
                    this.slidePrev()
                  }
                },
              },
            },

            window.addEventListener("resize", _this.onResize, false);
            if(sessionStorage.getItem('language')){
              this.lang = sessionStorage.getItem('language'); // 存入一个值
            }else{
              sessionStorage.setItem('language',this.lang); // 存入一个值
            }
        },
        beforeDestroy(){
          let _this = this
          _this.scene.remove(_this.model)
          _this.model.traverse(function (object) {
            if (object.type === 'Mesh') {
              object.geometry.dispose()
              object.material.dispose()
            }
          })
        },
        methods: {
          greet () {},
          /**
           * @description 打开链接
           * @param {*} link
           */
          openLink: function(link) {
            if (this.lang == 'cn') {
              window.open('https://www.jc-times.com/', '_blank');
            } else {
              window.open('https://en.jc-times.com/', '_blank');
            }
          },
          nextorprev(e){
            console.log(e);
          },
          /**
           * @description 相机动画
           */
          tweenCamera: function(oldP, oldT, newP, newT, callBack) {
            var _this = this
            if(_this.tween){
              _this.tween.stop()
            }
            _this.tween = new TWEEN.Tween({
              x1: oldP.x, // 相机x
              y1: oldP.y, // 相机y
              z1: oldP.z, // 相机z
              x2: oldT.x, // 控制点的中心点x
              y2: oldT.y, // 控制点的中心点y
              z2: oldT.z  // 控制点的中心点z
            });
            _this.tween.to({
              x1: newP.x,
              y1: newP.y,
              z1: newP.z,
              x2: newT.x,
              y2: newT.y,
              z2: newT.z
            }, 1000);
            _this.tween.onUpdate(function (object) {
              _this.camera.position.x = object.x1;
              _this.camera.position.y = object.y1;
              _this.camera.position.z = object.z1;
              _this.controls.target.x = object.x2;
              _this.controls.target.y = object.y2;
              _this.controls.target.z = object.z2;
              _this.controls.update();
            })
            _this.tween.onComplete(function () {
              _this.controls.enabled = true;
              callBack && callBack()
            })
            _this.tween.easing(TWEEN.Easing.Cubic.InOut);
            _this.tween.start();
          },

          /**
           * @description 初始化Canvas
           */
          initCanvas: function() {
              let _this = this;

              _this.clock = new THREE.Clock();

              // 创建渲染器
              _this.initRenderer();

              // 创建场景
              _this.initScene();

              // 创建相机
              _this.initCamera();

              // 创建相机控制器
              _this.initControls();

              // 创建环境贴图
              _this.initPmremGenerator();

              // 加载模型
              _this.loadModel();

          },

          /**
           * @description 初始化渲染器
           */
          initRenderer: function() {
              let _this = this;

              _this.container = this.$refs.webgl;
              _this.containerW = this.$refs.webgl.getBoundingClientRect().width;
              _this.containerH = this.$refs.webgl.getBoundingClientRect().height;

              _this.renderer = new THREE.WebGLRenderer({
                  antialias: true,
                  alpha: true
              });
              _this.renderer.setSize(this.containerW,this.containerH);
              _this.renderer.localClippingEnabled = true;
              _this.renderer.clippingPlanes = Object.freeze([])
              _this.renderer.setClearAlpha(0);

              _this.renderer.setPixelRatio(window.devicePixelRatio);
              _this.renderer.outputEncoding = THREE.sRGBEncoding;
              _this.container.appendChild(_this.renderer.domElement);
              // 调整曝光度
              _this.renderer.toneMapping =THREE.CineonToneMapping
              _this.renderer.toneMappingExposure=0.75

          },

          /**
           * @description 初始化场景
           */
          initScene: function() {
              let _this = this;

              _this.scene = new THREE.Scene();
          },

          /**
           * @description 初始化相机
           */
          initCamera: function() {
            let _this = this;
            _this.camera = new THREE.PerspectiveCamera(45, this.containerW / this.containerH, 0.1, 10000);
            _this.camera.position.set(0, 0, 50);
            _this.camera.lookAt(_this.scene.position);
          },

          /**
           * @description 初始化相机控制器
           */
          initControls: function() {
              let _this = this;

              _this.controls = new OrbitControls(_this.camera, _this.renderer.domElement);
              _this.controls.enablePan = false;
              _this.controls.enableDamping = true;
              _this.controls.dampingFactor = 0.1;
              _this.controls.maxPolarAngle = Math.PI;
              _this.controls.minPolarAngle = 0;
              _this.controls.enablePan = false;
              _this.controls.enableZoom = true;
          },

          /**
           * @description 初始化环境贴图
           */
          initPmremGenerator: function() {
            let _this = this;
            let pmremGenerator = new THREE.PMREMGenerator(_this.renderer);
            let loaderRGBE = new RGBELoader();
            pmremGenerator.compileEquirectangularShader()
            loaderRGBE.load('../../static/hdr/marry_hall_1k.hdr', texture => {
              const envMap = pmremGenerator.fromEquirectangular(texture).texture;
              _this.scene.environment = envMap;
              texture.dispose();
              pmremGenerator.dispose();
            })
          },

          /**
           * @description 加载模型文件
           */
          loadModel: function() {
              let _this = this;
              _this.textrueLoader = new THREE.TextureLoader();
              let loader = new GLTFLoader();

              loader.setMeshoptDecoder(MeshoptDecoder);
              loader.load("../../static/model/bgxkskkzz/bgxkskkzz-me.glb", function(gltf) {
                console.log(gltf,'gltf');
                _this.model = gltf.scene;

                // _this.model.scale.set(0.1, 0.1, 0.1);
                _this.modelLoaded = true;
                // _this.model.position.set(0, 100, 0);
                _this.scene.add(_this.model);
                _this.animate();

                _this.modelanimationList = gltf.animations

                // 材质共享问题
                _this.model.traverse(function (object) {
                  if (object.isMesh) {
                    object.material = object.material.clone();
                  }
                })

                _this.mixer = new THREE.AnimationMixer(_this.model);  //被此动作控制的 动画混合器
                //  获取gltf.animations[0]的第一个clip动画对象
                _this.clipAction = _this.mixer.clipAction(_this.modelanimationList[1]); //创建动画clipAction对象(动画剪辑 保存了此动作当中的动画数据)
                _this.clipAction.paused = true;
                _this.clipAction.time = 0;//物体状态为动画1秒对应状态
                _this.clipAction.loop = THREE.LoopOnce; //不循环播放
                _this.clipAction.clampWhenFinished = true // 物体状态停留在动画结束的时候
                _this.clipAction.play(); //播放动画
                _this.addDimension()
              });
          },

          /**
           * @description 循环渲染Canvas
           */
          animate: function() {
            let _this = this;

            _this.rafId = requestAnimationFrame(_this.animate);
            _this.controls.update();
            TWEEN.update();
            if(_this.mixer){
              let mixerUpdateDelta = _this.clock.getDelta();
              _this.mixer.update( mixerUpdateDelta );
            }
            // _this.composer.render(); // 使用处理对象渲染场景
            _this.renderer.render(_this.scene, _this.camera);
            // _this.labelRenderer.render(_this.scene, _this.camera); //渲染html标签
          },

          /**
           * @description 改变窗口大小，重新渲染Canvas
           */
          onResize: function() {
              let _this = this;
              _this.$nextTick(()=>{
                if(_this.$refs.webgl.getBoundingClientRect()){
                  _this.containerW = _this.$refs.webgl.getBoundingClientRect().width
                  _this.containerH = _this.$refs.webgl.getBoundingClientRect().height
                  _this.camera.aspect = _this.containerW / _this.containerH;
                  _this.camera.updateProjectionMatrix();
                  _this.renderer.setSize(_this.containerW, _this.containerH);
                }
              })
              // _this.labelRenderer.setSize(_this.containerW, _this.containerH);
          },

          /**
           * @description 选择语言
           */
          selectLang: function(e) {
              let _this = this;
              _this.lang = e;
              _this.toobarActive = '';
              _this.dismantleActive = '';
              _this.assembleActive = '';
          },

          /**
           * @description 选择菜单
           * @param {String} e 菜单
           */
          selectToobar: function(e) {
            let _this = this
            if(e == 'outer' && _this.toobarActive == 'outer'){
              _this.showallcomponents()
              if(_this.clipAction){ //如果有动画则先停止播放
                _this.clipAction.stop()
              }
              _this.mixer = new THREE.AnimationMixer(_this.model);  //被此动作控制的 动画混合器
              //  获取gltf.animations[0]的第一个clip动画对象
              _this.clipAction = _this.mixer.clipAction(_this.modelanimationList[1]); //创建动画clipAction对象(动画剪辑 保存了此动作当中的动画数据)
              _this.clipAction.paused = true;
              _this.clipAction.time = 0;//物体状态为动画1秒对应状态
              _this.clipAction.loop = THREE.LoopOnce; //不循环播放
              _this.clipAction.clampWhenFinished = true // 物体状态停留在动画结束的时候
              _this.clipAction.play(); //播放动画
            }
            if ( _this.toobarActive == e ) {
              _this.toobarActive = '';
              _this.showallcomponents()
              _this.transparentComponents(["cheban"],1,true)
              this.attentionStatus = false
              // _this.showallcomponents()
              if(_this.clipAction){ //如果有动画则先停止播放
                _this.clipAction.stop()
              }
              _this.mixer = new THREE.AnimationMixer(_this.model);  //被此动作控制的 动画混合器
              //  获取gltf.animations[0]的第一个clip动画对象
              _this.clipAction = _this.mixer.clipAction(_this.modelanimationList[1]); //创建动画clipAction对象(动画剪辑 保存了此动作当中的动画数据)
              _this.clipAction.paused = true;
              _this.clipAction.time = 0;//物体状态为动画1秒对应状态
              _this.clipAction.loop = THREE.LoopOnce; //不循环播放
              _this.clipAction.clampWhenFinished = true // 物体状态停留在动画结束的时候
              _this.clipAction.play(); //播放动画
            }else{
              this.attentionStatus = true
              _this.toobarActive = '';
              _this.$nextTick(()=>{
                this.toobarActive = e;
              })
            }
          },

          /**
           * @description 拆卸选项
           * @param {number} e 拆卸对象
           */
          upperAnimate: function(item) {
            let _this = this
            _this.upperActive = item.id
            _this.downActive = null
            _this.outerActive = null
            this.selectobject = item
            if (_this.lang == 'cn') {
              if(item.warn){
                _this.attentionText = item.warn;
              }else{
                _this.attentionText = null
              }
            } else {
              if(item.en_warn){
                _this.attentionText = item.en_warn;
              }else{
                _this.attentionText = null
              }
            }
            _this.showallcomponents()

            var oldP = { //旧的相机位置
              x: _this.camera.position.x,
              y: _this.camera.position.y,
              z: _this.camera.position.z,
            }
            var oldT = { //旧的聚焦位置
              x: _this.controls.target.x,
              y: _this.controls.target.y,
              z: _this.controls.target.z,
            }
            var newT = { //新的聚焦位置
              x: 0,
              y: 0,
              z: 0,
            }
            var newP = { //新的相机位置
              x: 0,
              y: 0,
              z: 50,
            }
            switch (item.id) {
              case 0:
                newP = { //新的相机位置
                  x: 45,
                  y: 8,
                  z: 25,
                }
                break;
              case 1:
                _this.ShowHideComponents(["dccb","xcb","mfp"],false)
                for (let i = 1; i < 8; i++) {
                  _this.ShowHideComponents([`LL${i}`],false)
                }
                newP = { //新的相机位置
                  x: 45,
                  y: 8,
                  z: 22,
                }
                break;
              case 2:
                _this.ShowHideComponents(["celuo","cheban","dccb","xcb","mfp"],false)
                for (let i = 1; i < 8; i++) {
                  _this.ShowHideComponents([`LL${i}`],false)
                }
                newP = { //新的相机位置
                  x: 40,
                  y: 8,
                  z: 18,
                }
                break;
              case 3:
                _this.ShowHideComponents(["gailuo","gaiban","celuo","cheban","dccb","xcb","mfp"],false)
                for (let i = 1; i < 8; i++) {
                  _this.ShowHideComponents([`LL${i}`],false)
                }
                newP = { //新的相机位置
                  x: 45,
                  y: 8,
                  z: 20,
                }
                break;
              case 4:
                _this.ShowHideComponents(["zhiluo","zhizhen","gailuo","gaiban","celuo","cheban","dccb","xcb","mfp"],false)
                for (let i = 1; i < 8; i++) {
                  _this.ShowHideComponents([`LL${i}`],false)
                }
                newP = { //新的相机位置
                  x: 45,
                  y: 8,
                  z: 25,
                }
                break;
              case 5:
                _this.ShowHideComponents(["yaluo","yakuai","zhiluo","zhizhen","gailuo","gaiban","celuo","cheban","dccb","xcb","mfp"],false)
                for (let i = 1; i < 8; i++) {
                  _this.ShowHideComponents([`LL${i}`],false)
                }
                newP = { //新的相机位置
                  x: 45,
                  y: 8,
                  z: 24,
                }
                break;
              case 6:
                _this.ShowHideComponents(["wc","tl","nc","yaluo","yakuai","zhiluo","zhizhen","gailuo","gaiban","celuo","cheban","dccb","xcb","mfp"],false)
                for (let i = 1; i < 8; i++) {
                  _this.ShowHideComponents([`LL${i}`],false)
                }
                newP = { //新的相机位置
                  x: 45,
                  y: 8,
                  z: 23,
                }
                break;
              case 7:
                _this.ShowHideComponents(["dl1","dl2","dk","wc","tl","nc","yaluo","yakuai","zhiluo","zhizhen","gailuo","gaiban","celuo","cheban","dccb","xcb","mfp"],false)
                for (let i = 1; i < 8; i++) {
                  _this.ShowHideComponents([`LL${i}`],false)
                }
                newP = { //新的相机位置
                  x: 45,
                  y: 3,
                  z: 18,
                }
                break;
              case 8:
                _this.ShowHideComponents(["bgsq","dl1","dl2","dk","wc","tl","nc","yaluo","yakuai","zhiluo","zhizhen","gailuo","gaiban","celuo","cheban","dccb","xcb","mfp"],false)
                for (let i = 1; i < 8; i++) {
                  _this.ShowHideComponents([`LL${i}`],false)
                }
                newP = { //新的相机位置
                  x: 43,
                  y: 2.8,
                  z: 30,
                }
                break;
              case 9:
                _this.ShowHideComponents(["ybl","yaban","bgsq","dl1","dl2","dk","wc","tl","nc","yaluo","yakuai","zhiluo","zhizhen","gailuo","gaiban","celuo","cheban","dccb","xcb","mfp"],false)
                for (let i = 1; i < 8; i++) {
                  _this.ShowHideComponents([`LL${i}`],false)
                }
                newP = { //新的相机位置
                  x: 0,
                  y: 60,
                  z: 100,
                }
                break;
              default:
                break;
            }
            if(item.id != 9){
              _this.tweenCamera(oldP, oldT, newP, newT);
            }else{
              let newP2 = { //新的相机位置
                x: 0,
                y: 50,
                z: 60,
              }
              // _this.tweenCamera(oldP, oldT, newP, newT,_this.tweenCamera(oldP, oldT, newP2, newT));
              _this.tweenCamera(oldP, oldT, newP, newT, function () {
                oldP = { //新的相机位置
                  x: 0,
                  y: 60,
                  z: 100,
                }
                _this.tweenCamera(oldP, oldT, newP2, newT);
              });
            }

            if(_this.clipAction){ //如果有动画则先停止播放
              _this.clipAction.stop()
            }
            //包含关键帧动画的模型作为参数创建一个播放器
            _this.mixer = new THREE.AnimationMixer(_this.model);  //被此动作控制的 动画混合器
            //  获取gltf.animations[0]的第一个clip动画对象
            _this.clipAction = _this.mixer.clipAction(_this.modelanimationList[item.animate_number]); //创建动画clipAction对象(动画剪辑 保存了此动作当中的动画数据)
            _this.clipAction.play(); //播放动画
            _this.clipAction.loop = THREE.LoopOnce; //不循环播放
            _this.clipAction.clampWhenFinished = true // 物体状态停留在动画结束的时候
            _this.mixer.addEventListener('finished', function( e ) { //全部动作的结束时调用
              // console.log('结束',item.id);
              // if(item.id == 1){
              //   _this.showhide()
              // }

            });
          },

          /**
           * @description 装配选项
           * @param {Number} e 装配对象
           */
          downAnimate: function(item) {
            let _this = this
            _this.outerActive = null
            _this.upperActive = null
            _this.downActive = item.id
            this.selectobject = item
            if (_this.lang == 'cn') {
              if(item.warn){
                _this.attentionText = item.warn;
              }else{
                _this.attentionText = null
              }
            } else {
              if(item.en_warn){
                _this.attentionText = item.en_warn;
              }else{
                _this.attentionText = null
              }
            }
            _this.showallcomponents()
            var oldP = { //旧的相机位置
              x: _this.camera.position.x,
              y: _this.camera.position.y,
              z: _this.camera.position.z,
            }
            var oldT = { //旧的聚焦位置
              x: _this.controls.target.x,
              y: _this.controls.target.y,
              z: _this.controls.target.z,
            }
            var newT = { //新的聚焦位置
              x: 0,
              y: 0,
              z: 0,
            }
            var newP = { //新的相机位置
              x: 0,
              y: 0,
              z: 50,
            }
            switch (item.id) {
              case 10:
                newP = { //新的相机位置
                  x: 0,
                  y: 60,
                  z: 100,
                }
                _this.ShowHideComponents(["ybl","yaban","bgsq","dl1","dl2","dk","wc","tl","nc","yaluo","yakuai","zhiluo","zhizhen","gailuo","gaiban","celuo","cheban","dccb","xcb","mfp"],false)
                for (let i = 1; i < 8; i++) {
                  _this.ShowHideComponents([`LL${i}`],false)
                }
                break;
              case 11:
                newP = { //新的相机位置
                  x: 0,
                  y: 0,
                  z: 50,
                }
                _this.ShowHideComponents(["bgsq","dl1","dl2","dk","wc","tl","nc","yaluo","yakuai","zhiluo","zhizhen","gailuo","gaiban","celuo","cheban","dccb","xcb","mfp"],false)
                for (let i = 1; i < 8; i++) {
                  _this.ShowHideComponents([`LL${i}`],false)
                }
                break;
              case 12:
                newP = { //新的相机位置
                  x: 0,
                  y: 15,
                  z: 50,
                }
                _this.ShowHideComponents(["dl1","dl2","dk","wc","tl","nc","yaluo","yakuai","zhiluo","zhizhen","gailuo","gaiban","celuo","cheban","dccb","xcb","mfp"],false)
                for (let i = 1; i < 8; i++) {
                  _this.ShowHideComponents([`LL${i}`],false)
                }
                break;
              case 13:
                newP = { //新的相机位置
                  x: 45,
                  y: 8,
                  z: 25,
                }
                _this.ShowHideComponents(["wc","tl","nc","yaluo","yakuai","zhiluo","zhizhen","gailuo","gaiban","celuo","cheban","dccb","xcb","mfp"],false)
                for (let i = 1; i < 8; i++) {
                  _this.ShowHideComponents([`LL${i}`],false)
                }
                break;
              case 14:
                newP = { //新的相机位置
                  x: 45,
                  y: 8,
                  z: 24,
                }
                _this.ShowHideComponents(["yaluo","yakuai","zhiluo","zhizhen","gailuo","gaiban","celuo","cheban","dccb","xcb","mfp"],false)
                for (let i = 1; i < 8; i++) {
                  _this.ShowHideComponents([`LL${i}`],false)
                }
                break;
              case 15:
                newP = { //新的相机位置
                  x: 45,
                  y: 8,
                  z: 23,
                }
                _this.ShowHideComponents(["zhiluo","zhizhen","gailuo","gaiban","celuo","cheban","dccb","xcb","mfp"],false)
                for (let i = 1; i < 8; i++) {
                  _this.ShowHideComponents([`LL${i}`],false)
                }
                break;
              case 16:
                newP = { //新的相机位置
                  x: 40,
                  y: 8,
                  z: 18,
                }
                _this.ShowHideComponents(["gailuo","gaiban","celuo","cheban","dccb","xcb","mfp"],false)
                for (let i = 1; i < 8; i++) {
                  _this.ShowHideComponents([`LL${i}`],false)
                }
                break;
              case 17:
                newP = { //新的相机位置
                  x: 40,
                  y: 4,
                  z: 18,
                }
                _this.ShowHideComponents(["celuo","cheban","dccb","xcb","mfp"],false)
                for (let i = 1; i < 8; i++) {
                  _this.ShowHideComponents([`LL${i}`],false)
                }
                break;
              case 18:
                newP = { //新的相机位置
                  x: 40,
                  y: 2.5,
                  z: 10,
                }
                _this.ShowHideComponents(["dccb","xcb","mfp"],false)
                for (let i = 1; i < 8; i++) {
                  _this.ShowHideComponents([`LL${i}`],false)
                }
                break;
              case 19:
                newP = { //新的相机位置
                  x: 45,
                  y: 8,
                  z: 25,
                }
                // _this.ShowHideComponents(["dccb","xcb","mfp"],false)
                // for (let i = 1; i < 8; i++) {
                //   _this.ShowHideComponents([`LL${i}`],false)
                // }
                break;
              default:
                break;
            }
            // _this.tweenCamera(oldP, oldT, newP, newT);
            if(item.id != 10){
              _this.tweenCamera(oldP, oldT, newP, newT);
            }else{
              let newP2 = { //新的相机位置
                x: 0,
                y: 50,
                z: 60,
              }
              // _this.tweenCamera(oldP, oldT, newP, newT,_this.tweenCamera(oldP, oldT, newP2, newT));
              _this.tweenCamera(oldP, oldT, newP, newT, function () {
                oldP = { //新的相机位置
                  x: 0,
                  y: 60,
                  z: 100,
                }
                _this.tweenCamera(oldP, oldT, newP2, newT);
              });
            }

            if(_this.clipAction){ //如果有动画则先停止播放
              _this.clipAction.stop()
            }
            //包含关键帧动画的模型作为参数创建一个播放器
            _this.mixer = new THREE.AnimationMixer(_this.model);  //被此动作控制的 动画混合器
            //  获取gltf.animations[0]的第一个clip动画对象
            _this.clipAction = _this.mixer.clipAction(_this.modelanimationList[item.animate_number]); //创建动画clipAction对象(动画剪辑 保存了此动作当中的动画数据)
            _this.clipAction.play(); //播放动画
            _this.clipAction.loop = THREE.LoopOnce; //不循环播放
            _this.clipAction.clampWhenFinished = true // 物体状态停留在动画结束的时候
            _this.mixer.addEventListener('finished', function( e ) { //全部动作的结束时调用
              // console.log('结束',item.id);
              // if(item.id == 1){
              //   _this.showhide()
              // }
            });
          },

          /**
           * @description 调节选项
           * @param {Number} e 调节对象
           */
          outerAnimate:function(item){
            let _this = this
            _this.upperActive = null
            _this.downActive = null
            _this.outerActive = item.id
            this.selectobject = item
            _this.showallcomponents()
            if (_this.lang == 'cn') {
              if(item.warn){
                _this.attentionText = item.warn;
              }else{
                _this.attentionText = null
              }
            } else {
              if(item.en_warn){
                _this.attentionText = item.en_warn;
              }else{
                _this.attentionText = null
              }
            }
            var oldT = { //旧的聚焦位置
              x: _this.controls.target.x,
              y: _this.controls.target.y,
              z: _this.controls.target.z,
            }
            var oldP = { //旧的相机位置
              x: _this.camera.position.x,
              y: _this.camera.position.y,
              z: _this.camera.position.z,
            }
            var newT = { //新的聚焦位置
              x: 0,
              y: 0,
              z: 0,
            }
            let newP = { //新的相机位置
              x: 35,
              y: 0,
              z: 20,
            }
            _this.tweenCamera(oldP, oldT, newP, newT);

            // _this.ShowHideComponents(["yaban","gaiban"],false)
            // console.log(_this.model.getObjectByName("dccb"));
            // console.log(_this.model.getObjectByName("xcb"));
            // console.log(_this.model.getObjectByName("mfp"));
            // console.log(_this.model.getObjectByName("ybl"));
            // console.log(_this.model.getObjectByName("yaban"));
            // console.log(_this.model.getObjectByName("gaiban"));
            // console.log(_this.model.getObjectByName("gailuo"));
            _this.ShowHideComponents(["dccb","xcb","mfp","ybl","yaban","gaiban","gailuo","zhizhen","zhiluo"],false)
            // _this.transparentComponents(["cheban"],0.4)
            for (let i = 1; i < 8; i++) {
              _this.ShowHideComponents([`LL${i}`],false)
            }

            if(_this.clipAction){ //如果有动画则先停止播放
              _this.clipAction.stop()
            }
            //包含关键帧动画的模型作为参数创建一个播放器
            _this.mixer = new THREE.AnimationMixer(_this.model);  //被此动作控制的 动画混合器
            if(item.id == 0){
              _this.clipAction = _this.mixer.clipAction(_this.modelanimationList[11]); //创建动画clipAction对象(动画剪辑 保存了此动作当中的动画数据)
            }else{
              _this.clipAction = _this.mixer.clipAction(_this.modelanimationList[12]); //创建动画clipAction对象(动画剪辑 保存了此动作当中的动画数据)
            }
            _this.clipAction.loop = THREE.LoopOnce; //不循环播放
            _this.clipAction.clampWhenFinished = true // 物体状态停留在动画结束的时候
            _this.clipAction.play(); //播放动画
          },
          /**
           * @description 显示所有组件(当前组件)
           */
          showallcomponents(){
            let _this = this
            _this.model.getObjectByName("dccb").visible = true
            _this.model.getObjectByName("xcb").visible = true
            _this.model.getObjectByName("mfp").visible = true
            _this.model.getObjectByName("celuo").visible = true
            _this.model.getObjectByName("cheban").visible = true
            _this.model.getObjectByName("gailuo").visible = true
            _this.model.getObjectByName("gaiban").visible = true
            _this.model.getObjectByName("zhiluo").visible = true
            _this.model.getObjectByName("zhizhen").visible = true
            _this.model.getObjectByName("yaluo").visible = true
            _this.model.getObjectByName("yakuai").visible = true
            _this.model.getObjectByName("wc").visible = true
            _this.model.getObjectByName("tl").visible = true
            _this.model.getObjectByName("nc").visible = true
            _this.model.getObjectByName("dl1").visible = true
            _this.model.getObjectByName("dl2").visible = true
            _this.model.getObjectByName("dk").visible = true
            _this.model.getObjectByName("ybl").visible = true
            _this.model.getObjectByName("yaban").visible = true
            _this.model.getObjectByName("bgsq").visible = true
            for (let i = 1; i < 8; i++){
              _this.model.getObjectByName("LL"+i).visible = true
            }
            for (let i = 1; i < 20; i++){
              _this.model.getObjectByName("bg"+i).visible = true
            }
          },
          /**
           * @description 显示隐藏组件
           * @param {array} e 隐藏名列表
           * @param {Boolean} e （0隐藏）or（1显示）
           */
          ShowHideComponents(objectArray,determine){
            let _this = this
            if(determine){ //显示
              for (let i = 0; i < objectArray.length; i++) {
                _this.model.getObjectByName(objectArray[i]).visible = true
                // if (object instanceof THREE.Mesh) {
                //   console.log("该对象是Mesh");
                // } else if (object instanceof THREE.Group) {
                //   console.log("该对象是Group");
                // } else {
                //   console.log("该对象不是Mesh也不是Group");
                // }
              }
            }else{ //隐藏
              for (let i = 0; i < objectArray.length; i++) {
                // console.log(objectArray[i]);
                _this.model.getObjectByName(objectArray[i]).visible = false
              }
            }
          },
          /**
           * @description 显示透明组件
           * @param {array} e 透明名列表
           * @param {Boolean} e （false透明）or（true取消透明）
           */
          transparentComponents(objectArray,opcity,determine = false){
            let _this = this
            if(determine){ //显示
              for (let i = 0; i < objectArray.length; i++) {
                if (_this.model.getObjectByName(objectArray[i]) instanceof THREE.Mesh) {
                  _this.model.getObjectByName(objectArray[i]).material.transparent = false
                  _this.model.getObjectByName(objectArray[i]).material.opacity = 1
                } else if (_this.model.getObjectByName(objectArray[i]) instanceof THREE.Group) {
                  for (let j = 0; j < _this.model.getObjectByName(objectArray[i]).children.length; j++) {
                    _this.model.getObjectByName(objectArray[i]).children[j].material.transparent = false
                    _this.model.getObjectByName(objectArray[i]).children[j].material.opacity = 1
                  }
                }
              }
            }else{ //透明
              for (let i = 0; i < objectArray.length; i++) {
                if (_this.model.getObjectByName(objectArray[i]) instanceof THREE.Mesh) {
                  _this.model.getObjectByName(objectArray[i]).material.transparent = true
                  _this.model.getObjectByName(objectArray[i]).material.opacity = opcity
                } else if (_this.model.getObjectByName(objectArray[i]) instanceof THREE.Group) {
                  for (let j = 0; j < _this.model.getObjectByName(objectArray[i]).children.length; j++) {
                    _this.model.getObjectByName(objectArray[i]).children[j].material.transparent = true
                    _this.model.getObjectByName(objectArray[i]).children[j].material.opacity = opcity
                  }
                }
              }
            }
          },
          //显示隐藏注意提示
          shownote(){
            this.is_hidenote = !this.is_hidenote
          },
          /**
           * @description 射线拾取模型
           */
          raycasterclick(){
            let _this = this
            _this.renderer.domElement.addEventListener('click', function (event) {
              // .offsetY、.offsetX以canvas画布左上角为坐标原点,单位px
              const px = event.offsetX;
              const py = event.offsetY;
              //屏幕坐标px、py转WebGL标准设备坐标x、y
              //width、height表示canvas画布宽高度
              const x = (px / event.srcElement.clientWidth) * 2 - 1;
              const y = -(py / event.srcElement.clientHeight) * 2 + 1;
              //创建一个射线投射器`Raycaster`
              const raycaster = new THREE.Raycaster();
              //.setFromCamera()计算射线投射器`Raycaster`的射线属性.ray
              // 形象点说就是在点击位置创建一条射线，射线穿过的模型代表选中
              raycaster.setFromCamera(new THREE.Vector2(x, y), _this.camera);
              //.intersectObjects([mesh1, mesh2, mesh3])对参数中的网格模型对象进行射线交叉计算
              // 未选中对象返回空数组[],选中一个对象，数组1个元素，选中两个对象，数组两个元素
              const intersects = raycaster.intersectObjects([_this.dimension_1]);
              // console.log("射线器返回对象", intersects);
              // intersects.length大于0说明，说明选中了模型
              if (intersects.length > 0) {
                // 声明一个三维向量用来表示某个坐标
                // const worldPosition = new THREE.Vector3();
                // 获取mesh的世界坐标，你会发现mesh的世界坐标受到父对象group的.position影响
                // intersects[0].object.getWorldPosition(worldPosition);
                // console.log('世界坐标',worldPosition);
                // console.log('本地坐标',intersects[0].object.position);
                // console.log("射线器返回对象", intersects);
                if(intersects[0].object.name == "dimension_1"){
                  _this.showallcomponents()
                  _this.ShowHideComponents(["dccb","xcb","mfp","ybl","yaban","gaiban","gailuo","zhizhen","zhiluo"],false)
                  for (let i = 1; i < 8; i++) {
                    _this.ShowHideComponents([`LL${i}`],false)
                  }
                  console.log('选中');
                  var oldP = { //旧的相机位置
                    x: _this.camera.position.x,
                    y: _this.camera.position.y,
                    z: _this.camera.position.z,
                  }
                  var oldT = { //旧的聚焦位置
                    x: _this.controls.target.x,
                    y: _this.controls.target.y,
                    z: _this.controls.target.z,
                  }
                  var newT = { //新的聚焦位置
                    x: 20,
                    y: 3,
                    z: 6,
                  }
                  var newP = { //新的相机位置
                    x: 20,
                    y: 30,
                    z: 40,
                  }
                  _this.oldCamera = { //旧的相机位置
                    x: _this.camera.position.x,
                    y: _this.camera.position.y,
                    z: _this.camera.position.z,
                  }
                  _this.tweenCamera(oldP, oldT, newP, newT);
                  _this.dimension_1.visible = false
                  _this.dimension_1_status = _this.dimension_1.visible
                }
              }else{
                console.log('null');
                // if(!_this.dimension_1.visible){
                //   _this.resetdimension(2)
                // }
              }
            })
          },
          resetdimension(gear){
            let _this = this
            _this.showallcomponents()
            _this.dimension_1.visible = true
            _this.dimension_1_status = _this.dimension_1.visible

            if(_this.clipAction){ //如果有动画则先停止播放
              _this.clipAction.stop()
            }
            _this.mixer = new THREE.AnimationMixer(_this.model);  //被此动作控制的 动画混合器
            //  获取gltf.animations[0]的第一个clip动画对象
            _this.clipAction = _this.mixer.clipAction(_this.modelanimationList[1]); //创建动画clipAction对象(动画剪辑 保存了此动作当中的动画数据)
            _this.clipAction.paused = true;
            _this.clipAction.time = 0;//物体状态为动画1秒对应状态
            _this.clipAction.loop = THREE.LoopOnce; //不循环播放
            _this.clipAction.clampWhenFinished = true // 物体状态停留在动画结束的时候
            _this.clipAction.play(); //播放动画
            if(gear == 2){
              var oldP = { //旧的相机位置
                x: _this.camera.position.x,
                y: _this.camera.position.y,
                z: _this.camera.position.z,
              }
              var oldT = { //旧的聚焦位置
                x: _this.controls.target.x,
                y: _this.controls.target.y,
                z: _this.controls.target.z,
              }
              var newT = { //新的聚焦位置
                x: 0,
                y: 0,
                z: 0,
              }
              // var newP = { //新的相机位置
              //   x: 0,
              //   y: 0,
              //   z: 50,
              // }
              _this.tweenCamera(oldP, oldT, _this.oldCamera, newT);
            }
          },
          addDimension(){
            let _this = this
            const texture = new THREE.TextureLoader().load("../../static/image/click.png");
            // 创建精灵材质对象SpriteMaterial
            const spriteMaterial = new THREE.SpriteMaterial({
              color:0xff0000,//设置颜色
              map:texture
            });
            // 创建精灵模型对象，不需要几何体geometry参数
            // const sprite = new THREE.Sprite(spriteMaterial);
            _this.dimension_1 = new THREE.Sprite(spriteMaterial);
            // _this.dimension_1.scale.set(1,1);  // 标注坐标
            _this.dimension_1.name='dimension_1';  // 标注坐标
            _this.dimension_1.position.set(20,3,6);  // 标注坐标
            this.model.add(_this.dimension_1);
          },
          handleChildEvent(){
            this.lang = sessionStorage.getItem('language')
            this.$refs.navchild.childchangelang();
            if (this.lang == 'cn') {
              if(this.selectobject.warn){
                this.attentionText = this.selectobject.warn;
              }else{
                this.attentionText = null
              }
            } else {
              if(this.selectobject.en_warn){
                this.attentionText = this.selectobject.en_warn;
              }else{
                this.attentionText = null
              }
            }
          },
          /**
           * @description 测试按钮
           */
          test(){
            let _this = this
            // 创建精灵材质对象SpriteMaterial
            // const spriteMaterial = new THREE.SpriteMaterial({
            //   color:0x00ffff,//设置颜色
            // });
            // // 创建精灵模型对象，不需要几何体geometry参数
            // const sprite = new THREE.Sprite(spriteMaterial);
            // this.model.add(sprite);
            // console.log(_this.model.getObjectByName("dk"),"dk");
            // console.log(_this.model.getObjectByName("ybl"),"ybl");
            // console.log(_this.model.getObjectByName("yaban"),"yaban");
            // console.log(_this.model.getObjectByName("bgsq"),"bgsq");
            // // console.log(_this.model.getObjectByName("lagan"),"lagan");
            console.log(_this.camera.position.x,_this.camera.position.y,_this.camera.position.z);
            // for (let i = 1; i < 9; i++) {
            //   console.log(_this.model.getObjectByName("LL"+i),"LL"+i);
            // }
            // for (let i = 1; i < 20; i++) {
            //   console.log(_this.model.getObjectByName("bg"+i),"bg"+i);
            // }
            // console.log(_this.model.getObjectByName("yaban"));
          },
        }
    }
</script>

<style scoped>
  .v-enter{
    opacity: 0;
  }
  .v-enter-to{
    opacity: 1;
  }
  .v-enter-active{
    transition: all 1s;
  }
  .v-leave{
    opacity: 1;
  }
  .v-leave-to{
    opacity: 0;
  }
  .v-leave-active{
    transition: all 1s;
  }
  .swiper{
    /* border: 1px solid #000; */
    position: absolute;
    width: 54vw;
    height: 50px;
    left: 50%;
    top: 0;
    -webkit-transform: translate(-50%,-150%);
    transform: translate(-50%,-150%);
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .swiper-container {
    width: 50vw !important;
  }
  .swiper-slide{
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
  }
  .app-toolbar .app-submenu-wrap .app-submenu-item{
    margin: 0px 0px;
  }
  .test{
    position: absolute;
    z-index: 10000;
    top: 0px;
    background-color: red;
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    cursor: pointer;
  }
  .arrow-left{
    /* background-color: #34353a; */
    width: 30px;
    height: 30px;
    border-right: 15px solid #34353a;
    border-left: 15px solid #34353a00;
    border-top: 15px solid #34353a00;
    border-bottom: 15px solid #34353a00;
    cursor: pointer;
  }
  .arrow-right{
    /* background-color: #34353a; */
    width: 30px;
    height: 30px;
    border-left: 15px solid #34353a;
    border-right: 15px solid #34353a00;
    border-top: 15px solid #34353a00;
    border-bottom: 15px solid #34353a00;
    cursor: pointer;
  }
  .swiper-button-disabled{
    opacity: 0.5;
  }
  .Mask{
    position: absolute;
    top: 0;
    z-index: 100;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.3);
  }
  .Mask_img{
    position: absolute;
    top: 15%;
    right: 50px;
    width: 600px;
    padding: 20px;
    background-color: #fff;
    border-radius: 10px;
  }
  .Mask_img img{
    width: 100%;
  }
  @media (max-width:1620px) {
    .swiper{
      width: 56vw !important;
    }
  }
  @media (max-width:996px) {
    .swiper{
      width: 70vw !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/bgxkskkzz.vue